export default "__VITE_ASSET__e32de6c0__"